import script from "./livestreamingCredit.vue?vue&type=script&setup=true&lang=ts"
export * from "./livestreamingCredit.vue?vue&type=script&setup=true&lang=ts"

import "./livestreamingCredit.vue?vue&type=style&index=0&id=a4596918&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4596918"]])

export default __exports__